import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "item-card-action": "",
  "data-testid": "rc-item-card-action"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RcItemCardAction',
  setup(__props) {

/**
 * RcItemCardAction
 *
 * This component is used to wrap any interactive elements (like buttons, links)
 * inside an RcItemCard so they don't trigger the card-click event.
 *
 * Usage:
 *
 * <rc-item-card-action @click="doSomething">
 *   <a href="#">Click me</a>
 * </rc-item-card-action>
 *
 */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})